import getIn from 'transmute/getIn';
export const getIOSMobile = getIn(['isIOSMobile']);